import React, { useMemo } from "react";
import {
  ControllerType,
  useControllerContext,
} from "./EngineAndControllerProvider";
import { PartsRow } from "./PartsRow";
import { useSearchMade } from "../hooks/useSearchMade";
import { useControllerState } from "../../../../coveo/utils/useControllerState";
import { FeaturedPartCategoryList } from "./FeaturePartCategoryList";
import { SearchResults } from "./SearchResults";
import { useQuerySimpleGQL } from "../../../../../hooks/useSimpleGQL";
import { FeaturedPartCategoryCollectionDTO } from "../../../../../api/Parts/Types";
import { PartService } from "../../../../../api/Parts/PartsService";
import { getOrderedResults } from "../../../../coveo/utils/orderResults";

export const ResultsSection: React.FC = () => {
  const searchMade = useSearchMade();

  const resultListController = useControllerContext(ControllerType.ResultList);
  const resultListState = useControllerState(resultListController);

  const featuredParts = useMemo(
    () => getOrderedResults(resultListState.results, "featured_part_order"),
    [resultListState.results],
  );

  const newParts = useMemo(
    () => getOrderedResults(resultListState.results, "new_part_order"),
    [resultListState.results],
  );

  const { result } = useQuerySimpleGQL<FeaturedPartCategoryCollectionDTO, []>(
    "featuredPartCategories",
    [],
    PartService.queryFeaturedPartCategories,
    () => !searchMade,
  );

  if (!searchMade) {
    return (
      <div>
        <FeaturedPartCategoryList
          featuredPartCategories={
            result.data?.featuredPartCategories?.collection ?? undefined
          }
          isLoading={result?.isLoading ?? false}
        />
        <PartsRow results={featuredParts} title="Featured Parts" />
        <PartsRow
          results={newParts}
          title="New Parts"
          wrapperClassName="mb-[56px]"
        />
      </div>
    );
  }

  return <SearchResults results={resultListState.results} />;
};
